import { createSelector } from 'reselect';
import { variantsListForSuggestedProducts, suggestedProductsForDifferentDesignMode, isBoxProductSelector } from '../../../../../../../redux/product/product.selectors';
export const suggestedProductListSelector = createSelector(suggestedProductsForDifferentDesignMode, variantsListForSuggestedProducts, isBoxProductSelector, (suggestedProducts, listOfNearestVariants, isBlockHidden) => ({
  listOfNearestVariants,
  suggestedProducts,
  isBlockHidden
}));